import React from 'react'
import { Route } from 'react-router-dom'
import CLIENT_ENDPOINTS from '../../../constants/client-endpoints'
import SystemScreen from '../screen'

const SettingsRoutes = () => {
    return (
        <React.Fragment>
            <Route path={CLIENT_ENDPOINTS.SYSTEM} component={SystemScreen} />
        </React.Fragment>
    )
}

export default SettingsRoutes